import { DatePipe } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import {
  DownloadActivityService,
  DownloadList,
} from './download-activity.service';
import { Table } from 'primeng/table';
interface PageEvent {
  first: number;
  rows: number;
}
@Component({
  selector: 'app-download-reports',
  templateUrl: './download-reports.component.html',
  styleUrls: ['./download-reports.component.scss'],
})
export class DownloadReportsComponent {
  date!: string;
  firstIndex: number = 0;
  rows: number = 0;
  columns: any[] = [];
  downloadTracks: DownloadList[] = [];
  rowsPerPage: any;
  totalRecords: number = 0;
  lastIndex!: number;
  pageNumber!: number;
  isSearchListFetching: boolean = false;
  firstTimeSearch: boolean = false;
  currentSortField: string = 'lastAuthentication.asc';
  sortOrder: 'asc' | 'desc' | null = null;
  currentField: string = '';
  @ViewChild(Table) table: Table | undefined;

  searchForm: UntypedFormGroup = new UntypedFormGroup({
    selectedDates: new UntypedFormControl('', []),
    textValue: new UntypedFormControl('', []),
  });
  constructor(
    private spinner: NgxSpinnerService,
    private notifierService: NotifierService,
    private datePipe: DatePipe,
    private downloadActivityService: DownloadActivityService
  ) {
    this.firstIndex = 0;
    this.rows = 10;
    this.columns = [
      {
        name: 'User Name',
        field: 'userName',
        sortable: true,
      },
      {
        name: 'Download Date',
        field: 'downloadTime',
        sortable: true,
      },
      {
        name: 'IP Address',
        field: 'ipAddress',
        sortable: false,
      },
      {
        name: 'Product Name',
        field: 'productName',
        sortable: true,
      },
      {
        name: 'Title',
        field: 'title',
        sortable: true,
      },
      {
        name: 'Date',
        field: 'date',
        sortable: false,
      },
      {
        name: 'Version',
        field: 'version',
        sortable: false,
      },
    ];
  }

  ngOnInit(): void {
    this.handleGetSearchList();
    this.spinner.show();

    this.firstTimeSearch = true;
  }
  paginate(event: PageEvent): void {
    this.pageNumber = event.first / event.rows + 1;
  }
  clearText() {
    this.searchForm.controls['textValue'].patchValue('');
    this.searchForm.controls['selectedDates'].patchValue('');
  }
  handleGetSearchList() {
    this.spinner.show();
    this.isSearchListFetching = true;
    this.firstTimeSearch = false;

    const data = this.searchForm.getRawValue();
    this.downloadActivityService
      .getDownloadActivityResult({
        userName: data.textValue,
        downloadTime: data.selectedDates,
      })
      .subscribe((data) => {
        this.downloadTracks = [];
        this.handleSearchResponse(data);
        this.spinner.hide();
        this.isSearchListFetching = false;
        this.table?.reset();
      });
    this.spinner.hide();
  }
  handleSearchResponse(data: any) {
    this.downloadTracks = data.map((item: DownloadList) => {
      return {
        ...item,
        downloadTime: this.adjustDateToUserTimezone(item.downloadTime),
      };
    });
  }
  adjustDateToUserTimezone(dateString: string): string {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(dateString);
    const userDate = new Date(
      date.toLocaleString('en-US', { timeZone: userTimezone })
    );
    return userDate.toLocaleString();
  }
  onSort(field: string) {
    if (this.currentField.includes(field)) {
      if (this.currentSortField == 'lastAuthentication.asc') {
        this.currentSortField = 'lastAuthentication.desc';
        return;
      }
      // Toggle sort order if the same field is sorted again
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      this.currentSortField = field + '.' + this.sortOrder;
    } else {
      // Set new field and default to ascending order
      this.sortOrder = 'asc';

      this.currentSortField = field + '.' + this.sortOrder;
    }
  }
}
